/**
 * @generated SignedSource<<1e030f492dad4e4a9362b6dcc6b14199>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BookActionEnum = "book_delete" | "book_rescrap" | "book_scrap_create" | "book_scraps_classification" | "book_submit" | "book_update" | "scrap_source_book_create" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BookActionsMutationButtonStack_book$data = {
  readonly actions: ReadonlyArray<BookActionEnum>;
  readonly id: string;
  readonly " $fragmentType": "BookActionsMutationButtonStack_book";
};
export type BookActionsMutationButtonStack_book$key = {
  readonly " $data"?: BookActionsMutationButtonStack_book$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookActionsMutationButtonStack_book">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookActionsMutationButtonStack_book",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    }
  ],
  "type": "Book",
  "abstractKey": null
};

(node as any).hash = "18c280e84061d339266ba26b321bde7b";

export default node;
